import type {
  Category,
  Feature,
  NavItem,
  Product,
  ShowcaseCard,
  StatItem
} from '../../../types';

export const navItems: NavItem[] = [
  { id: 1, label: 'Inicio', href: '#inicio' },
  { id: 2, label: 'Categorías', href: '#categorias' },
  { id: 3, label: 'Destacados', href: '#destacados' },
  { id: 4, label: 'Novedades', href: '#novedades' },
  { id: 5, label: 'Visítanos', href: '#visitanos' },
  { id: 6, label: 'Contacto', href: '#contacto' }
];

export const heroStats: StatItem[] = [
  { id: 1, value: '+150', label: 'Productos publicados' },
  { id: 2, value: '24h', label: 'Tiempo estimado de respuesta' },
  { id: 3, value: 'CRC', label: 'Moneda lista para Costa Rica' }
];

export const categories: Category[] = [
  {
    id: 1,
    title: 'Mujer',
    description: 'Vestidos, blusas, jeans y accesorios para colecciones principales.',
    image:
      'https://images.unsplash.com/photo-1483985988355-763728e1935b?auto=format&fit=crop&w=900&q=80',
    itemCount: 42
  },
  {
    id: 2,
    title: 'Hombre',
    description: 'Prendas casuales, sport y básicos premium para vitrinas modernas.',
    image:
      'https://images.unsplash.com/photo-1515886657613-9f3515b0c78f?auto=format&fit=crop&w=900&q=80',
    itemCount: 28
  },
  {
    id: 3,
    title: 'Niña',
    description: 'Conjuntos cómodos, looks frescos y colecciones infantiles destacadas.',
    image:
      'https://images.unsplash.com/photo-1519345182560-3f2917c472ef?auto=format&fit=crop&w=900&q=80',
    itemCount: 17
  },
  {
    id: 4,
    title: 'Bebés',
    description: 'Bodies, enterizos y prendas suaves para una línea delicada y tierna.',
    image:
      'https://images.unsplash.com/photo-1515488042361-ee00e0ddd4e4?auto=format&fit=crop&w=900&q=80',
    itemCount: 14
  }
];

export const featuredProducts: Product[] = [
  {
    id: 1,
    name: 'Blazer estructurado beige',
    price: 18500,
    image:
      'https://images.unsplash.com/photo-1529139574466-a303027c1d8b?auto=format&fit=crop&w=900&q=80',
    category: 'Mujer',
    badge: 'Top venta',
    sizes: ['S', 'M', 'L']
  },
  {
    id: 2,
    name: 'Camisa slim fit azul marino',
    price: 14900,
    image:
      'https://images.unsplash.com/photo-1603252109303-2751441dd157?auto=format&fit=crop&w=900&q=80',
    category: 'Hombre',
    badge: 'Nuevo',
    sizes: ['M', 'L', 'XL']
  },
  {
    id: 3,
    name: 'Vestido midi satinado',
    price: 15900,
    oldPrice: 18900,
    image:
      'https://images.unsplash.com/photo-1496747611176-843222e1e57c?auto=format&fit=crop&w=900&q=80',
    category: 'Mujer',
    badge: 'Oferta',
    sizes: ['S', 'M']
  },
  {
    id: 4,
    name: 'Conjunto infantil floral',
    price: 9800,
    image:
      'https://images.unsplash.com/photo-1512436991641-6745cdb1723f?auto=format&fit=crop&w=900&q=80',
    category: 'Niña',
    sizes: ['4-5', '6-7']
  }
];

export const newArrivals: Product[] = [
  {
    id: 5,
    name: 'Jeans rectos lavado oscuro',
    price: 13600,
    image:
      'https://images.unsplash.com/photo-1542272604-787c3835535d?auto=format&fit=crop&w=900&q=80',
    category: 'Hombre',
    badge: 'Reciente',
    sizes: ['30', '32', '34']
  },
  {
    id: 6,
    name: 'Blusa manga globo minimal',
    price: 11800,
    image:
      'https://images.unsplash.com/photo-1434389677669-e08b4cac3105?auto=format&fit=crop&w=900&q=80',
    category: 'Mujer',
    sizes: ['S', 'M', 'L']
  },
  {
    id: 7,
    name: 'Body de algodón premium',
    price: 6900,
    image:
      'https://images.unsplash.com/photo-1519238263530-99bdd11df2ea?auto=format&fit=crop&w=900&q=80',
    category: 'Bebés',
    sizes: ['3M', '6M', '9M']
  },
  {
    id: 8,
    name: 'Set deportivo casual',
    price: 17200,
    oldPrice: 20500,
    image:
      'https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?auto=format&fit=crop&w=900&q=80',
    category: 'Hombre',
    badge: 'Promo',
    sizes: ['M', 'L']
  }
];

export const weeklyDeals: Product[] = [
  {
    id: 9,
    name: 'Pantalón sastre recto',
    price: 12900,
    oldPrice: 15900,
    image:
      'https://images.unsplash.com/photo-1541099649105-f69ad21f3246?auto=format&fit=crop&w=900&q=80',
    category: 'Mujer',
    badge: '-18%',
    sizes: ['S', 'M', 'L']
  },
  {
    id: 10,
    name: 'Falda estampada tribal',
    price: 13500,
    oldPrice: 16500,
    image:
      'https://images.unsplash.com/photo-1583496661160-fb5886a13d77?auto=format&fit=crop&w=900&q=80',
    category: 'Mujer',
    badge: 'Especial',
    sizes: ['S', 'M']
  },
  {
    id: 11,
    name: 'Loción corporal premium',
    price: 12500,
    image:
      'https://images.unsplash.com/photo-1522335789203-aabd1fc54bc9?auto=format&fit=crop&w=900&q=80',
    category: 'Belleza',
    badge: 'Popular'
  },
  {
    id: 12,
    name: 'Sudadera comfy unisex',
    price: 16400,
    oldPrice: 19900,
    image:
      'https://images.unsplash.com/photo-1521572267360-ee0c2909d518?auto=format&fit=crop&w=900&q=80',
    category: 'Unisex',
    sizes: ['M', 'L', 'XL']
  }
];

export const featureItems: Feature[] = [
  {
    id: 1,
    title: 'Diseño modular',
    description: 'Cada bloque vive en su propio componente .tsx para escalar fácilmente.'
  },
  {
    id: 2,
    title: 'Datos quemados',
    description: 'Listo para reemplazar por consumo real desde tu backend o CMS.'
  },
  {
    id: 3,
    title: 'Paleta personalizada',
    description: 'Aplicada con los tonos crema, azul, blanco, negro y grises de tu referencia.'
  }
];

export const showcaseCards: ShowcaseCard[] = [
  {
    id: 1,
    tag: 'Agenda una visita',
    title: 'Atención boutique más cercana',
    description: 'Bloque ideal para destacar citas presenciales, showroom o atención personalizada.',
    image:
      'https://images.unsplash.com/photo-1524504388940-b1c1722653e1?auto=format&fit=crop&w=1200&q=80'
  },
  {
    id: 2,
    tag: 'Colección cápsula',
    title: 'Nuevas combinaciones para temporada',
    description: 'Espacio visual para campañas, marcas aliadas o promociones especiales.',
    image:
      'https://images.unsplash.com/photo-1495385794356-15371f348c31?auto=format&fit=crop&w=1200&q=80'
  }
];
